import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const MoreInfo = ({ id, entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);

  return (
    <div id={id} className="Paragraph MoreInfo">
      <Container small>
        <div className="row">
          <div className="MoreInfo__inner col-12">
            <h3 className="MoreInfo__title">{title}</h3>
            <WysiwygField
              property="schema:text"
              className="ParagraphText__body"
              html={body}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MoreInfo;
